import { Button, Row } from "antd";
import React, { useState } from "react";
import TmsModal from "../../../../../../components/tms-customs/tms-modal";
import TmsSmRalArrearList from "../created-list-inner-pages/tms-sm-ral-arears-list";
import TmsArearsCreation from "../creation-inner-pages/tms-arears-creation";
const LandArrearIndex = () => {
  const [visible, setVisible] = useState(false);

  return (
    <div>
      <Row justify="start">
        <Button
          type="primary"
          onClick={() => {
            setVisible(true);
          }}
        >
          New Arrear Creation
        </Button>
      </Row>
      <br />
      {!visible && <TmsSmRalArrearList />}
      <TmsModal
        centered={true}
        width="80%"
        closable={false}
        style={{ margin: "30px 0px" }}
        visible={visible}
        title={"Arrear Creation "}
        onClose={() => {
          setVisible(false);
        }}
      >
        {visible && <TmsArearsCreation setVisible={setVisible} />}
      </TmsModal>
    </div>
  );
};

export default LandArrearIndex;
